import { useTranslation } from 'react-i18next'

import { ICON_COLOR, ICON_HEIGHT_24, IconWithTooltip } from '../../Icon'

import * as styles from './EmailPriorityTag.module.css'

import PriorityFilledIcon from '../../../icons/priority-filled.svg'

function EmailPriorityTag({ className = styles.EmailPriorityTag }) {
  const { t } = useTranslation()

  return (
    <IconWithTooltip
      Icon={PriorityFilledIcon}
      className={className}
      color={ICON_COLOR.Orange}
      size={ICON_HEIGHT_24}
      tooltip={t('Email.HighPriorityHintKey')}
    />
  )
}

export default EmailPriorityTag
